module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kuenten-5f3eef34307d60bf6321e5f8772fd7c3.svg";